import { Avatar, Box, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import {
  useGetEmployeeOnboardingStatusLabel,
  useGetLabourEngagementStateLabel,
} from './hooks/use-get-employment-state-labels';

type Props = {
  name: string;
  profilePictureUrl?: string;
  isOnboarded: boolean;
  labourEngagementState?: 'pending' | 'approved' | 'rejected' | 'terminated' | null;
};

export const EmployeeDetailHeader = ({
  name,
  profilePictureUrl,
  isOnboarded,
  labourEngagementState,
}: Props) => {
  const onboardedLabel = useGetEmployeeOnboardingStatusLabel(isOnboarded);
  const stateLabel = useGetLabourEngagementStateLabel(labourEngagementState);

  return (
    <Wrapper>
      <StyledAvatar src={profilePictureUrl} />
      <AboutUser>
        <EmployeeName>{name}</EmployeeName>
        <OnboardingStatus>
          {onboardedLabel} ({stateLabel})
        </OnboardingStatus>
      </AboutUser>
    </Wrapper>
  );
};

const AboutUser = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  paddingBottom: theme.spacing(6),
  paddingTop: theme.spacing(8),
  gap: theme.spacing(6),
}));

const AVATAR_SIZE = 89;

const StyledAvatar = styled(Avatar)({
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
});

const EmployeeName = styled(Typography)({
  fontSize: '24px',
  fontVariationSettings: '"wght" 700',
  fontFamily: 'Urbanist',
});

const OnboardingStatus = styled(Typography)({
  fontSize: '14px',
  fontVariationSettings: '"wght" 500',
  fontFamily: 'Urbanist',
});
